import { HttpParams } from "@angular/common/http";
import { AotCompiler } from "@angular/compiler";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { WebAPIService } from "projects/tn-library/src/lib/services/webApi.service";
import { Observable } from "rxjs";
import { userLoginModel } from "../models/userLoginModel.model";
import { userModel } from "../models/userModel.model";
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders } from "@angular/common/http";
import { catchError, map } from "rxjs/internal/operators";
import { AppService } from "./app.service";

@Injectable({providedIn: 'root'})
export class LoginService extends AppService {

    constructor(private http: HttpClient, @Inject('environment') environment: any) { 
        super(http, environment);
    }

    login(userLogin: userLoginModel) {
        this.clearSession();
        return this.http.post(this.getEndpoint('auth'), userLogin).pipe(
            map(res => {
                this.setSession(res)
                return res;
            }));
    }

    logout(userLogin: userLoginModel) {
        this.clearSession();
    }

    getUserRole() {

    }

    private setSession(user: any): void {
        console.log("Token Name: " + this.TOKEN_NAME);
        localStorage.setItem(this.TOKEN_NAME, JSON.stringify(user));
      }

      clearSession(): void {
        localStorage.clear();
      }


}

